// ── Rotating site background (2026-10-14) ───────────────────────────────────
// Once per page load, fetch the list of background photos (GET /backgrounds →
// getBackgrounds Lambda, which lists s3://sharc-prod-images/site-backgrounds/),
// pick one at random — never the photo this browser showed last time — and
// preload it. Once it has downloaded, it is set on body as --sharc-bg-image and
// body gets .sharc-bg-ready, which fades the body::after layer in over the
// bundled default (body::before). See index.css.
//
// Runs outside React (called once from index.js), so it covers both the
// signed-in app and the logged-out sign-in screen. Every failure path (network,
// non-200, empty folder, image load error, storage blocked) silently leaves the
// default photo in place.
// Ref: SHARC_Spec_Rotating_Backgrounds_2026-10-14.docx
import config from './config';

const LAST_KEY = 'sharc.lastBackground';

function readLast() {
    try {
        return window.localStorage.getItem(LAST_KEY);
    } catch (e) {
        return null;
    }
}

function writeLast(url) {
    try {
        window.localStorage.setItem(LAST_KEY, url);
    } catch (e) {
        // Storage blocked (private mode etc.) — repeats are possible, nothing else.
    }
}

function pickBackground(list) {
    const last = readLast();
    const pool = list.length > 1 ? list.filter(u => u !== last) : list;
    const from = pool.length > 0 ? pool : list;
    return from[Math.floor(Math.random() * from.length)];
}

export function startBackgroundRotation() {
    if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;

    window.fetch(`${config.API_URL}/backgrounds`)
        .then(res => (res.ok ? res.json() : null))
        .then(data => {
            const list = data && Array.isArray(data.backgrounds)
                ? data.backgrounds.filter(u => typeof u === 'string' && u.length > 0)
                : [];
            if (list.length === 0) return;

            const choice = pickBackground(list);
            const img = new Image();
            img.onload = () => {
                document.body.style.setProperty('--sharc-bg-image', `url("${choice.replace(/"/g, '%22')}")`);
                // Next frame, so the opacity transition always runs.
                window.requestAnimationFrame(() => document.body.classList.add('sharc-bg-ready'));
                writeLast(choice);
            };
            img.src = choice;
        })
        .catch(() => {
            // Keep the default background.
        });
}
